interface UrbanismeFeature {
  properties?: { libelle?: string; txt?: string }
}

interface UrbanismeDetailsProps {
  data: { features?: UrbanismeFeature[] } | null
  error?: unknown
}

export const UrbanismeDetails = ({ data, error }: UrbanismeDetailsProps) => {
  if (error) return <div className="text-sm text-destructive py-2">Erreur de chargement</div>

  return (
    <ul className="pt-2 space-y-1.5">
      {data?.features?.map((item, index) => (
        <li key={index} className="flex items-start gap-2 text-sm text-gray-600">
          <span className="w-1 h-1 rounded-full bg-gray-400 mt-1.5 shrink-0" />
          {`${item.properties?.libelle}${item.properties?.txt && item.properties?.txt !== "" ? ` : (${item.properties?.txt})` : ""}`}
        </li>
      ))}
    </ul>
  )
}
